import { createFileRoute } from '@tanstack/react-router'

import { Landing } from '@/components/marketing/landing'

export const Route = createFileRoute('/')({
  component: Landing,
})
